import React, { memo, useCallback, useState } from "react";

// utils
import { isEmpty } from "@swiggy-private/js-utils";

//styles
import { OfferText, Relative, StyledTooltip, TooltipContainer, TooltipText } from "./styles";

//components
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";
import { TURBO_PAYMENT_METHOD_WIDGET_DATA_TEST_IDS } from "@swiggy-private/payment-test-ids";

const MAX_LENGTH = 25;
const OFFER_AVAILABLE = "Offer available"; //TODO: this will be changed to dynamic value in next milestones

function DiscountMessage({ discount }: { discount?: string }) {
    const [showTooltip, setShowTooltip] = useState(false);

    const onClose = useCallback(() => {
        setShowTooltip(false);
    }, []);

    const onClick = useCallback(() => {
        setShowTooltip(true);
    }, []);

    if (isEmpty(discount)) {
        return null;
    }

    //TODO: we will be changing this to dynamic value in next milestones
    //If the content is less than MAX_LENGTH characters, we will show it as it is, otherwise we will show it as "Offer available" Tooltip
    if (discount.length < MAX_LENGTH) {
        return (
            <Text variant="V2.body3.neutral.regular" color="positive">
                {discount}
            </Text>
        );
    }

    return (
        <Relative tabIndex={0} aria-label={discount}>
            <OfferText variant="V2.body3.neutral.regular" onClick={onClick} color="positive">
                {OFFER_AVAILABLE}
            </OfferText>
            {showTooltip && (
                <TooltipContainer data-testid={TURBO_PAYMENT_METHOD_WIDGET_DATA_TEST_IDS.DISCOUNT_TOOLTIP}>
                    <StyledTooltip onClickClose={onClose}>
                        <TooltipText variant="V2.body3.neutral.regular" color="text_inverse_Highest_Emphasis">
                            {discount}
                        </TooltipText>
                    </StyledTooltip>
                </TooltipContainer>
            )}
        </Relative>
    );
}

export default memo(DiscountMessage);
